import axios from "axios";
import { BASE_URL } from "../config/config";

export const dataURItoBlob = async (file, setImage) => {
  console.log("file", file);
  let formData = new FormData();
  formData.append("file", file);

  try {
    const response = await axios.post(
      `${BASE_URL}/aws/file?email=birds`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const uploadedUrl = response.data.url;
    setImage(uploadedUrl);
    console.log("Uploaded URL:", uploadedUrl);
  } catch (error) {
    console.error("Error uploading file:", error);
  }
};
